/*
 | -------------------------------------------------------------
 |  --> type: component
 |  --> name: skip links
 | -------------------------------------------------------------
 |
 |  Functionality for skip links.
 |
*/

/* -------------------------------------------------------------
 | variables
 | -------------------------------------------------------------
 */

const skipLinks = [...document.querySelectorAll('[data-skip-link]')]

/* -------------------------------------------------------------
 | execution
 | -------------------------------------------------------------
 */

// check if skip links is on the page then add event listener for every skip link
if (skipLinks.length > 0) {
  skipLinks.forEach(link => {
    link.addEventListener('keydown', event => {
      // if keydown event is nog on the skip link itself, return and exit
      if (!event.target.closest('[data-skip-link]')) return
      const key = event.key
      // if keydown event is nog an enter, return and exit
      if (key !== 'Enter') return
      // prevent default anchor behaviour
      event.preventDefault()
      const target = event.target.getAttribute('href')

      // set focus to first menu item for skip link to main navigation
      if (target === '#main-navigation') {
        document.querySelector('[data-navigation-main="menu"]').querySelector('a').focus()
      }

      // set focus to first h1 for skip link to main content
      if (target === '#main-content') {
        document.querySelector('h1').focus()
      }
    })
  })
}
